import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { getRemotionEnvironment } from 'remotion';

// During a Lambda/Studio render the bundle is served from S3 with no /locales endpoint, so the http
// backend 403s on every chunk. Skip it (and the detector) there; t() falls back to keys, as on the 403.
const instance = getRemotionEnvironment().isRendering
  ? i18n.use(initReactI18next)
  : i18n.use(LanguageDetector).use(Backend).use(initReactI18next);

instance.init({
  initAsync: false,
  debug: false,
  interpolation: {
    escapeValue: false
  },
  backend: {
    loadPath: '/locales/{{lng}}/{{ns}}.json'
  },
  react: {
    useSuspense: false
  },
  // Component/scene namespaces hold their own keys; anything not found there
  // (shared generics like DELETE/DONE, or not-yet-migrated keys) resolves from
  // translation.json so a namespaced useTranslation() never regresses copy.
  defaultNS: 'translation',
  fallbackNS: 'translation',
  supportedLngs: ['en', 'es'],
  fallbackLng: 'en',
  load: 'currentOnly'
});

export default i18n;
